// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Router, { useRouter } from 'next/router';
import { useQuery } from '@tanstack/react-query';
import Fetch from '@/utils/Fetch';
import InvoiceDetail from '@/components/customer-zone/invoice/invoice-detail';
import InvoiceItems from '@/components/customer-zone/invoice/invoice-items';
import InvoiceTotals from '@/components/customer-zone/invoice/invoice-totals';
import { colors, layout, shadows } from '@/theme/';
import ButtonDropdown from '@/components/button-dropdown';
import DownloadService from '@/utils/download-service';
import Breadcrumbs from "@/components/breadcrumbs";
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import { createFileRoute } from '@tanstack/react-router'

function ViewInvoice() {
  const router = useRouter();
  const { id } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

  const { data: invoice } = useQuery(
    ['invoice', id],
    () => Fetch.get({ url: `/Invoice`, params: { id } }),
    { enabled: !!id }
  );

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  useEffect(() => {
    const subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  if (!invoice) return null;

  const primaryContact = invoice.Contact ? invoice.Contact : undefined;
  const quoteLocation = invoice.Location ? invoice.Location : undefined;

  const exportDocument = (endPoint: any) => {
    DownloadService.downloadFile("GET", `/Invoice/${endPoint}`, null, true, false);
  };

  const printOptions = [
    { text: 'Invoice', link: `GetInvoiceDocument?invoiceID=${invoice.ID}` }
  ];

  return (
    <div className="manage-container">
      <div className="row">
        <Breadcrumbs currPage={{ text: invoice.InvoiceNumber, link: `/invoice/view/${invoice.ID}`, type: 'view' }} />
      </div>
      <div className="row">
        <div className="contact">
          {primaryContact ?
            <>
              <div className="heading">{primaryContact.FirstName + " " + primaryContact.LastName}</div>
              <p>{invoice.CustomerName}</p>
              <p>{primaryContact.MobileNumber}</p>
              <p>{primaryContact.EmailAddress}</p>
            </>
            : ""}
          <p>{quoteLocation ? quoteLocation.LocationDisplay : "No Location"}</p>
        </div>
        <div className="actions">
          <div className="button-dropdown">
            <ButtonDropdown
              disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
              action={exportDocument}
              text="Print"
              options={printOptions}
            />
          </div>
        </div>
      </div>
      <br />
      <InvoiceDetail invoice={invoice} showPrint={false} showTotals={false} showHyperlink={false} />
      <br />
      <InvoiceItems invoiceItems={invoice.InvoiceItems} />
      <br />
      <InvoiceTotals invoice={invoice} />

      <style jsx>{`  
        .card {
          background-color: ${colors.white};
          border-radius: ${layout.cardRadius};
          box-shadow: ${shadows.card};
          box-sizing: border-box;
          padding: 1rem 2rem;
          position: relative;
          width: 100%;
        }  
        .card h3 {
            margin-top: 0;
        }
        .row {
          display: flex;
        }
        .column {
          display: flex;
          flex-basis: 0;
          flex-direction: column;
          flex-grow: 1;
        }
        .column :global(.textarea-container) {
          height: 100%;
        }
        .column + .column {
          margin-left: 1.25rem;
        }
        .contact {
          color: ${colors.blueGrey};
          width: 100%;
          padding-right: 16px;
        }
        .contact h1 {
          color: ${colors.darkPrimary};
          font-size: 2rem;
          margin: 0 0 0.75rem;
        }
        .contact p {
          margin: 3px 0 0;
          opacity: 0.8;
        }
        .heading {
          color: ${colors.blueGrey};
          font-weight: bold;
        }
        .loader {
          border-color: rgba(113, 143, 162, 0.2);
          border-left-color: ${colors.blueGrey};
          display: block;
          margin-bottom: 1rem;
          margin-top: 1rem;
        }
        .comment {
          background-color: ${colors.white};
          border-radius: ${layout.cardRadius};
          box-sizing: border-box;
          color: ${colors.blueGrey};
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-top: 0.5rem;
          padding: 1.25rem 1rem;
          position: relative;
          width: 100%;
        }
        .comment-info {
          align-items: center;
          display: flex;
          margin-bottom: 4px;
        }
        .job {
          color: ${colors.bluePrimary};
          font-weight: bold;
        }
        .name {
          color: ${colors.darkPrimary};
          font-weight: bold;
        }
        .time {
          color: ${colors.blueGrey};
          font-size: 12px;
          margin-left: 1rem;
        }
        .text {
          white-space: pre-wrap;
        }
        .edit {
          margin-top: 0.2rem;
          margin-left: 1rem;
        }
        .status {
          position: absolute;
          right: 0;
          top: 0;
          width: 20rem;
        }
        .status :global(.input-container){
          background-color: ${colors.bluePrimary};
        }
        .status :global(input){
          color: ${colors.white};
        }
        .status :global(label){
          color: ${colors.white};
          opacity: 0.8;
        }
        .actions {
          display: flex;
          flex-direction: row;
        }
        .message-button-container {
          align-items: center;
          border: 1px solid ${colors.blueGreyLight};
          border-radius: ${layout.cardRadius};
          box-sizing: border-box;
          cursor: pointer;
          display: flex;
          font-weight: bold;
          height: 2.5rem;
          justify-content: space-between;
          margin-top: 0.5rem;
          padding: 0.5rem 0.5rem 0.5rem 0.5rem;
          position: relative;
          margin-right: 0.5rem;
        }
        .button-dropdown {
          width: 200px;
        }
         
      `}</style>
    </div>
  );
}

export default ViewInvoice;

export const Route = createFileRoute('/_authenticated/invoice/view/$id')({ component: ViewInvoice })
